import React from "react";
import Footer from '../footer';
import AppDrawer from '../drawer';
import Cart from '../cart';
import Checkout from '../checkout';
import SearchBox from '../search';
import about from "../../assets/about.mp4";
import { BannerVideoAboutUs } from "../../styles/aboutUs";
import { InfoCompanyAboutUs }from "../../components/InfoCompanyAboutUs";

const About = () => {
  return (
    <>
      <BannerVideoAboutUs src={about} autoPlay loop muted controls></BannerVideoAboutUs>
      <InfoCompanyAboutUs />
      <Footer />
      <AppDrawer />
      <Cart />
      <Checkout />
      <SearchBox />
    </>
  );
};

export default About;
